import { createMuiTheme, Theme, ThemeOptions } from '@material-ui/core/styles'
import { PaletteColorOptions } from '@material-ui/core/styles/createPalette'

import { ColorsPalette } from './colors'

export interface CustomPalette {
  loading?: PaletteColorOptions
}
export interface CustomThemeOptions extends ThemeOptions {
  palette: ThemeOptions['palette'] & ColorsPalette
}

export interface extensionTheme {
  palette: Theme['palette'] & ColorsPalette & CustomPalette
  name: string
}
export type Modify<T, R> = Omit<T, keyof R> & R

export type CustomTheme = Modify<Theme, extensionTheme>

export const createMyTheme = (themeOptions: CustomThemeOptions, name: string): CustomTheme => {
  const baseTheme = createMuiTheme(themeOptions)

  return {
    ...baseTheme,
    name,
  }
}
